enum RangeHowEnum {
	endToEnd = 2,
	endToStart = 3,
	startToEnd = 1,
	startToStart = 0
}

export default RangeHowEnum;
